import React from 'react';
import './nomina.css';

// Grupos de DOCUMENTO_ENVIADO que muestra la barra de avance del periodo
export const GRUPOS_ESTADO = [
  { key: 'exitoso', label: 'Exitoso', estados: ['2', '4'] },
  { key: 'error', label: 'Error', estados: ['3'] },
  { key: 'noEnviado', label: 'No enviado', estados: ['0', '1', '5'] },
];

const MESES = ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'];

// Barra segmentada con la proporción de documentos del periodo por grupo de estado.
// Tocar un segmento o un ítem de la leyenda filtra la tabla por ese grupo (otra vez, lo quita).
// Con periodo seleccionado siempre se muestra (vacía si no hay documentos) para que no desaparezca.
const ProgresoPeriodo = ({ periodo, documentos, grupo, onGrupo }) => {
  if (!periodo) return null;
  const total = documentos.length;

  const grupos = GRUPOS_ESTADO.map((g) => {
    const n = documentos.filter((d) => g.estados.indexOf(String(d.DOCUMENTO_ENVIADO)) !== -1).length;
    return { ...g, n, pct: total ? (n * 100) / total : 0 };
  });
  const nombrePeriodo = `${MESES[Number(periodo.slice(4, 6)) - 1]} ${periodo.slice(0, 4)}`;
  const alternar = (key) => onGrupo(grupo === key ? null : key);

  return (
    <div className="nom-progreso">
      <div className="nom-progreso-titulo">
        <span>Documentos de {nombrePeriodo}</span>
        <span className="nom-progreso-total">{total ? `${total} documentos` : 'Sin documentos en este periodo'}</span>
      </div>

      <div className="nom-progreso-barra" role="group" aria-label={`Documentos de ${nombrePeriodo} por estado`}>
        {grupos.filter((g) => g.n > 0).map((g) => (
          <button
            key={g.key}
            type="button"
            className={`nom-progreso-seg nom-grupo-${g.key}` + (grupo && grupo !== g.key ? ' atenuado' : '')}
            style={{ width: `${g.pct}%` }}
            onClick={() => alternar(g.key)}
            title={`${g.label}: ${g.n}`}
            aria-label={`Ver ${g.label}: ${g.n} documentos`}
          />
        ))}
      </div>

      <div className="nom-progreso-leyenda">
        {grupos.map((g) => (
          <button
            key={g.key}
            type="button"
            className={'nom-progreso-item' + (grupo === g.key ? ' active' : '')}
            onClick={() => alternar(g.key)}
            disabled={g.n === 0}
            aria-pressed={grupo === g.key}
          >
            <span className={`nom-progreso-punto nom-grupo-${g.key}`} />
            {g.label} <b className={`nom-progreso-dato nom-texto-${g.key}`}>{g.n}</b>
          </button>
        ))}
      </div>
    </div>
  );
};

export default ProgresoPeriodo;



// WEBPACK FOOTER //
// ./src/components/nomina/components/ProgresoPeriodo.jsx